/* ==========================================================================
   SHEHAR — Editorial behaviour layer
   Theme: Avnish (Focal v1.2). Loaded deferred, after theme.js.
   Vanilla only. No libraries. Safe to run on every page.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DESKTOP = '(min-width: 741px)';

  /* ------------------------------------------------------------------------
     1. Scroll reveal
     Elements marked [data-shehar-reveal] fade + rise once, then are unobserved.
     If IntersectionObserver is missing, everything reveals immediately.
     ---------------------------------------------------------------------- */
  function initReveal() {
    var targets = document.querySelectorAll('[data-shehar-reveal]:not(.is-revealed)');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('is-revealed');
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var j = 0; j < targets.length; j++) {
      observer.observe(targets[j]);
    }
  }

  /* ------------------------------------------------------------------------
     2. Hero video
     The <picture> poster is rendered server-side and is the LCP element.
     The video carries no src until we know the viewport, so only ONE of the
     desktop/mobile files is ever downloaded. It fades in over the poster.
     ---------------------------------------------------------------------- */
  function initHeroVideo(video) {
    if (!video || video.dataset.sheharInit === 'true') return;

    var desktop = video.getAttribute('data-desktop-src');
    var mobile = video.getAttribute('data-mobile-src');
    var wantsDesktop = window.matchMedia(DESKTOP).matches;
    var src = wantsDesktop ? desktop || mobile : mobile || desktop;

    if (!src) return;

    // Honour the visitor's motion preference: keep the still poster instead.
    if (reduceMotion.matches) return;

    video.dataset.sheharInit = 'true';

    video.addEventListener(
      'canplay',
      function () {
        video.classList.add('is-playing');
      },
      { once: true }
    );

    video.src = src;
    video.load();

    var attempt = video.play();
    if (attempt && typeof attempt.catch === 'function') {
      // Autoplay can be refused (low power mode, data saver). Poster stays.
      attempt.catch(function () {});
    }
  }

  function initHeroes() {
    var videos = document.querySelectorAll('.shehar-hero__video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < videos.length; i++) initHeroVideo(videos[i]);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          initHeroVideo(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '200px' }
    );

    for (var j = 0; j < videos.length; j++) observer.observe(videos[j]);
  }

  /* ------------------------------------------------------------------------
     3. Header scroll state
     Adds .shehar-scrolled to <html> past the fold threshold so the header can
     transition from transparent overlay to solid. Throttled with rAF.
     ---------------------------------------------------------------------- */
  function initHeaderState() {
    var root = document.documentElement;
    var ticking = false;
    var threshold = 40;

    function update() {
      root.classList.toggle('shehar-scrolled', window.scrollY > threshold);
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ------------------------------------------------------------------------
     Boot. Focal and the theme editor re-render sections without a page
     reload, so re-initialise on shopify:section:load.
     ---------------------------------------------------------------------- */
  function boot() {
    initReveal();
    initHeroes();
    initHeaderState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initHeroes();
  });
})();
